import React, { useState, useEffect } from "react";
import moment from "moment";
import Commongrid from "../../common/Commongrid";
import { useNavigate } from "react-router-dom";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import HomeIcon from "@mui/icons-material/Home";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { getHubName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";

const SummaryCard = ({ title, value, color, icon }) => (
  <div className="bg-white rounded-2xl px-5 py-4 w-[260px]">
    <div className="flex items-center justify-between">
      <h3 className="text-md font-medium text-gray-500">{title}</h3>
      <div className="text-xl bg-gray-100 p-2 rounded-lg">{icon}</div>
    </div>

    <div className="mt-4 text-left">
      <p className={`text-3xl font-bold ${color}`}>{value ?? 0}</p>
    </div>
  </div>
);

const Deliveriesandpickups = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const [hubs, setHubs] = useState([]);
  const [selectedCity, setSelectedCity] = useState("1");
  const [selectedHub, setSelectedHub] = useState("1");
  const [activeTab, setActiveTab] = useState("deliveries");
  const [subTab, setSubTab] = useState("today");
  const [deliveriesData, setDeliveriesData] = useState([]);
  const [pickupsData, setPickupsData] = useState([]);
  const [pickupTodayData, setPickupTodayData] = useState([]);
  const [pickupWeeklyData, setPickupWeeklyData] = useState([]);

  const [summary, setSummary] = useState({
    total: 0,
    hub: 0,
    home: 0,
  });

  const [pickupSummary, setPickupSummary] = useState({
    total: 0,
    hub: 0,
    home: 0,
  });

  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;

  const getHubAPI = async (cityId) => {
    const apiDetails = await getHubName(cityId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
    setSelectedHub("1");
  };

  const columns = [
    {
      field: "isAssigned",
      headerName: "Agent Assignment Status",
      minWidth: 200,
      renderCell: (params) => (
        <span
          className={`px-2 py-1 rounded text-white text-sm ${
            params.row.isAssigned ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {params.row.isAssigned ? "Assigned" : "Not Assigned"}
        </span>
      ),
    },
    { 
      field: "bookingCode",
      headerName: "Booking Code",
      minWidth: 160,
      renderCell: (params) => (
        <span
          className="text-blue-600 cursor-pointer hover:underline"
          onClick={() => {
            const navigate = `/viewallbookings?bookingid=${params?.row?.bookingCode}&id=${params?.row?.id}&display=true`;
            window.open(navigate, "_blank");
          }}
        >
          {params.value}
        </span>
      ),
    },
    { field: "bookingStatus", headerName: "Booking Status", minWidth: 180 },
    {
      field: "deliveryType",
      headerName: activeTab === "deliveries" ? "Delivery Type" : "Pickup Type",
      minWidth: 160,
    },
    { field: "vehicleNumber", headerName: "Vehicle No", minWidth: 140 },
    {
      field: "isDelivered",
      headerName:
        activeTab === "deliveries" ? "Delivery Status" : "Pickup Status",
      minWidth: 160,
      renderCell: (params) => {
        const delivered = params.row.isDelivered;

        return (
          <span
            className={`px-2 py-1 rounded text-white text-sm ${
              delivered === "Not Delivered" || delivered === "Not Picked Up"
                ? "bg-red-400"
                : "bg-orange-400"
            }`}
          >
            {delivered}
          </span>
        );
      },
    },
    { field: "bookFrom", headerName: "Delivery Date/Time", minWidth: 180 },
    { field: "bookTo", headerName: "Pickup Date/Time", minWidth: 180 },
    { field: "customerName", headerName: "Customer Name", minWidth: 160 },
    { field: "customerEmail", headerName: "Customer Email", minWidth: 200 },
  ];

  const rows = activeTab === "deliveries" ? pickupsData : pickupWeeklyData;

  const data = activeTab === "deliveries" ? deliveriesData : pickupsData;

  const getBookings = async () => {
    if (!token) {
      return toast.error(
        "Authentication token not found. Please log in again.",
      );
    }
    if (!selectedCity || !selectedHub) return;
    try {
      const res = await fetch(
        `${apiUrl}/api/fleetdeliveryagentbookings/todays-delivery?cityId=${selectedCity}&hubId=${selectedHub}`,
        { headers: { Authorization: token } },
      );

      const result = await res.json();

      if (result?.statusCode === "0100") {
        setSummary({
          total: result?.dataValues?.totalDeliveries,
          hub: result?.dataValues?.hubDeliverys,
          home: result?.dataValues?.homeDeliveries,
        });

        const deliveriesFormatted = result?.dataValues?.bookings.map(
          (item) => ({
            vehicleName: item.vehicleName,
            vehicleNumber: item.vehicleRegistrationNo,
            bookFrom: item.bookFrom,
            bookingCode: item.bookingCode,
            bookingStatus: fleetBookingStatus?.[item?.bookingStatus] || "",
            customerName: item.customerName,
            customerEmail: item.customerEmail,
            odometer: item.currentOdometer,
            image: item.vehicleImage || "/no-car.png",
            deliveryType: item.deliveryType,
            isAssigned: item.isDeliveryAgentAssigned,
          }),
        );

        const actionRequiredFormatted =
          result?.dataValues?.currentWeekBookingWithoutDelivery.map((item) => ({
            id: item.id,
            bookingCode: item.bookingCode,
            bookingStatus: fleetBookingStatus?.[item?.bookingStatus] || "",
            customerName: item.customerName,
            customerEmail: item.customerEmail,
            vehicleName: item.vehicleName || "-",
            vehicleNumber: item.vehicleRegistrationNo,
            isDelivered: moment(item.bookFrom).isBefore(moment())
              ? "Not Delivered"
              : "Pending",
            bookFrom: moment(item.bookFrom).format("MMM Do YYYY, h:mm A"),
            bookTo: moment(item.bookTo).format("MMM Do YYYY, h:mm A"),
            isAssigned: item.isDeliveryAgentAssigned,
            deliveryType: item.deliveryType,
          }));

        setDeliveriesData(deliveriesFormatted);
        setPickupsData(actionRequiredFormatted);
      }
    } catch (err) {
      console.log("API ERROR", err);
    }
  };

  const getPickupBookings = async () => {
    if (!token) {
      return toast.error("Authentication token not found.");
    }

    if (!selectedCity || !selectedHub) return;

    try {
      const res = await fetch(
        `${apiUrl}/api/fleetpickupagentbookings/todays-pickup?cityId=${selectedCity}&hubId=${selectedHub}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      const result = await res.json();

      if (result?.statusCode === "0100") {
        setPickupSummary({
          total: result?.dataValues?.totalPickup || 0,
          hub: result?.dataValues?.hubPickups || 0,
          home: result?.dataValues?.homePickups || 0,
        });

        const formattedData =
          result?.dataValues?.bookings?.map((item) => ({
            vehicleName: item.vehicleName,
            vehicleNumber: item.vehicleRegistrationNo,
            bookFrom: item.bookFrom,
            bookTo: item.bookTo,
            bookingCode: item.bookingCode,
            bookingStatus: fleetBookingStatus?.[item?.bookingStatus] || "",
            customerName: item.customerName,
            customerEmail: item.customerEmail,
            odometer: item.currentOdometer,
            image: item.vehicleImage || "/no-car.png",
            deliveryType: item.pickupType,
            pickupType: item.pickupType,
            isAssigned: item.isPickupAgentAssigned,
          })) || [];

        const weeklyPickupFormatted = (
          result?.dataValues?.currentWeekBookingWithoutPickup || []
        ).map((item) => ({
          id: item.id,
          bookingCode: item.bookingCode,
          bookingStatus: fleetBookingStatus?.[item?.bookingStatus] || "",
          customerName: item.customerName,
          customerEmail: item.customerEmail,
          vehicleName: item.vehicleName || "-",
          vehicleNumber: item.vehicleRegistrationNo,
          isDelivered: moment(item.bookTo).isBefore(moment())
            ? "Not Picked Up"
            : "Pending",
          bookFrom: moment(item.bookFrom).format("MMM Do YYYY, h:mm A"),
          bookTo: moment(item.bookTo).format("MMM Do YYYY, h:mm A"),
          isAssigned: item.isPickupAgentAssigned,
          deliveryType: item.pickupType,
        }));

        setPickupTodayData(formattedData);
        setPickupWeeklyData(weeklyPickupFormatted);
      }
    } catch (err) {
      console.log("PICKUP API ERROR", err);
    }
  };

  useEffect(() => {
    if (selectedCity) {
      getHubAPI(selectedCity);
      setSelectedHub("");
    }
  }, [selectedCity]);

  useEffect(() => {
    if (!token || !selectedCity || !selectedHub) return;
    getBookings();
    getPickupBookings();
    const interval = setInterval(() => {
      getBookings();
      getPickupBookings();
    }, 600000);
    return () => clearInterval(interval);
  }, [token, selectedCity, selectedHub]);

  const Card = ({ data }) => {
    const [flipped, setFlipped] = useState(false);
    const isHome =
      data.deliveryType === "homeDelivery" ||
      data.deliveryType === "homePickup";
    return (
      <section
        className="h-[400px] cursor-pointer mb-2"
        onClick={() => setFlipped(!flipped)}
      >
        <article
          className="relative w-full h-full transition-transform duration-500"
          style={{
            transformStyle: "preserve-3d",
            transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front */}
          <div
            className={`absolute inset-0 rounded-xl overflow-hidden border ${
              isHome
                ? "bg-orange-50 border-orange-300"
                : "bg-green-50 border-green-300"
            }`}
            style={{ backfaceVisibility: "hidden" }}
          >
            <span
              className={`absolute top-2 right-2 w-6 h-6 text-xs flex items-center justify-center rounded-full text-white ${
                data.isAssigned ? "bg-green-500" : "bg-red-500"
              }`}
            >
              {data.isAssigned ? "✓" : "✕"}
            </span>

            <img
              src={data.image}
              alt="car"
              className="w-full h-[150px] object-cover"
            />

            <section className="p-2 text-center space-y-1">
              <p
                className={`text-xl font-bold flex items-center justify-center gap-2 ${
                  isHome ? "text-orange-600" : "text-green-600"
                }`}
              >
                {isHome ? <HomeIcon /> : <WarehouseIcon />}
                {activeTab === "deliveries"
                  ? isHome
                    ? "Home Delivery"
                    : "Hub Delivery"
                  : isHome
                    ? "Home Pickup"
                    : "Hub Pickup"}
              </p>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(
                    `/viewallbookings?bookingid=${data.bookingCode}&id=${data?.id}&display=true`,
                    "_blank",
                  );
                }}
                className="text-xl font-semibold text-blue-600 hover:underline"
              >
                {data.bookingCode}
              </button>

              <p className="text-lg text-blue-500 font-semibold">
                {data.bookingStatus}
              </p>

              <p className="text-lg font-bold text-red-500">
                {data.vehicleName} - {data.vehicleNumber}
              </p>

              <p className="text-md text-gray-500">
                Odometer: <span className="font-semibold">{data.odometer}</span>
              </p>

              <p className="text-lg">
                {activeTab === "deliveries"
                  ? "Delivery date/time"
                  : "Pickup date/time"}
                <br />
                <b>
                  {moment(
                    activeTab === "deliveries" ? data.bookFrom : data.bookTo,
                  ).format("MMM Do YYYY, h:mm A")}
                </b>
              </p>
            </section>
          </div>

          {/* Back */}
          <div
            className={`absolute inset-0 rounded-xl p-3 text-center shadow-md ${
              isHome
                ? "bg-orange-100 border border-orange-300"
                : "bg-green-100 border border-green-300"
            }`}
            style={{
              backfaceVisibility: "hidden",
              transform: "rotateY(180deg)",
            }}
          >
            <h3 className="text-xl font-bold mb-2">Customer Details</h3>
            <p className="text-lg text-gray-500">
              <b>{data.customerName}</b>
            </p>
            <p className="text-lg text-gray-500 break-words mt-1">
              {data.customerEmail}
            </p>
          </div>
        </article>
      </section>
    );
  };

  return (
    <div className="p-8">
      <div className="flex gap-10 mb-6 border-b pb-2">
        <h1
          onClick={() => {
            setActiveTab("deliveries");
            setSubTab("today");
          }}
          className={`text-3xl cursor-pointer pb-2 ${
            activeTab === "deliveries"
              ? "border-b-4 border-blue-600 font-bold text-black"
              : "text-gray-400"
          }`}
        >
          Deliveries
        </h1>

        <h1
          onClick={() => {
            setActiveTab("pickups");
            setSubTab("today");
          }}
          className={`text-3xl cursor-pointer pb-2 ${
            activeTab === "pickups"
              ? "border-b-4 border-blue-600 font-bold text-black"
              : "text-gray-400"
          }`}
        >
          Pickups
        </h1>
      </div>

      <div className="flex gap-4 mb-9">
        <div className="w-60">
          <label className="block text-lg font-semibold mb-1">City</label>
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
          >
            <option value="">Select City</option>
            {cities &&
              Object.entries(cities).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
          </select>
        </div>

        <div className="w-60">
          <label className="block text-lg font-semibold mb-1">Hub</label>
          <select
            value={selectedHub}
            onChange={(e) => setSelectedHub(e.target.value)}
            disabled={!selectedCity}
            className="w-full border rounded-lg px-3 py-2"
          >
            <option value="">Select Hub</option>
            {hubs.map((hub) => (
              <option key={hub.id} value={hub.id}>
                {hub.hubName}
              </option>
            ))}
          </select>
        </div>
      </div>

      {subTab === "today" ? (
        activeTab === "deliveries" ? (
          <div className="flex gap-3 flex-wrap mb-5">
            <SummaryCard
              title="Today Total Deliveries"
              value={summary.total}
              color="text-pink-600"
              icon={<DirectionsCarIcon />}
            />
            <SummaryCard
              title="Today Hub Deliveries"
              value={summary.hub}
              color="text-green-600"
              icon={<WarehouseIcon />}
            />
            <SummaryCard
              title="Today Home Deliveries"
              value={summary.home}
              color="text-orange-600"
              icon={<HomeIcon />}
            />
          </div>
        ) : (
          <div className="flex gap-3 flex-wrap mb-5">
            <SummaryCard
              title="Today Total Pickups"
              value={pickupSummary.total}
              color="text-pink-600"
              icon={<DirectionsCarIcon />}
            />
            <SummaryCard
              title="Today Hub Pickups"
              value={pickupSummary.hub}
              color="text-green-600"
              icon={<WarehouseIcon />}
            />
            <SummaryCard
              title="Today Home Pickups"
              value={pickupSummary.home}
              color="text-orange-600"
              icon={<HomeIcon />}
            />
          </div>
        )
      ) : activeTab === "deliveries" ? (
        <div className="flex gap-3 flex-wrap mb-5">
          <SummaryCard
            title="Total Weekly Bookings"
            value={pickupsData.length}
            color="text-pink-600"
            icon={<DirectionsCarIcon />}
          />
          <SummaryCard
            title="Weekly Assigned Bookings"
            value={pickupsData.filter((item) => item.isAssigned).length}
            color="text-green-600"
            icon={<CheckCircleRoundedIcon />}
          />
          <SummaryCard
            title="Weekly Unassigned Bookings"
            value={pickupsData.filter((item) => !item.isAssigned).length}
            color="text-orange-600"
            icon={<CancelRoundedIcon />}
          />
        </div>
      ) : (
        <div className="flex gap-3 flex-wrap mb-5">
          <SummaryCard
            title="Total Weekly Pickups"
            value={pickupWeeklyData.length}
            color="text-pink-600"
            icon={<DirectionsCarIcon />}
          />
          <SummaryCard
            title="Weekly Assigned Pickups"
            value={pickupWeeklyData.filter((item) => item.isAssigned).length}
            color="text-green-600"
            icon={<CheckCircleRoundedIcon />}
          />
          <SummaryCard
            title="Weekly Unassigned Pickups"
            value={pickupWeeklyData.filter((item) => !item.isAssigned).length}
            color="text-orange-600"
            icon={<CancelRoundedIcon />}
          />
        </div>
      )}

      <div className="flex gap-6 mb-5">
        <div
          onClick={() => setSubTab("today")}
          className={`cursor-pointer pb-2 text-xl ${
            subTab === "today"
              ? "border-b-2 border-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {activeTab === "deliveries" ? "Today Deliveries" : "Today Pickups"}
        </div>

        <div
          onClick={() => setSubTab("weekly")}
          className={`cursor-pointer pb-2 text-xl ${
            subTab === "weekly"
              ? "border-b-2 border-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {activeTab === "deliveries" ? "Weekly Deliveries" : "Weekly Pickups"}
        </div>
      </div>

      {subTab === "today" ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {(activeTab === "deliveries" ? deliveriesData : pickupTodayData)
            .length === 0 ? (
            <p className="text-gray-500">No Data Available</p>
          ) : (
            (activeTab === "deliveries" ? deliveriesData : pickupTodayData).map(
              (item, index) => <Card key={index} data={item} />,
            )
          )}
        </div>
      ) : (
        <div className="mt-4">
          <Commongrid
            rows={rows}
            columns={columns}
            totalCount={rows.length}
            handleViewClick={() => {}}
            disableColumnMenu={true}
          />
        </div>
      )}
    </div>
  );
};

export default Deliveriesandpickups;
